import { html } from "lit";
import { renderStandardPictureElement } from "../../../utils";

interface TeaserTileProps {
    imgDimensions?: [number, number];
    title: string;
}

export const TeaserTileTemplate = ({
    imgDimensions = [770, 360],
    title,
}: TeaserTileProps) => {
    return html` <ux-iws-link-wrapper class="ux-teaser-tile">
        <div class="ux-teaser-tile__overlay"></div>
        ${renderStandardPictureElement({
            width: imgDimensions[0],
            height: imgDimensions[1],
        })}
        <a class="ux-teaser-tile__content">
            <h3 class="ux-teaser-tile__title ux-u-text-bold">${title}</h3>
            <span class="ux-teaser-tile__cta"
                >Mehr erfahren <ux-icon name="arrow-small-right"></ux-icon
            ></span>
        </a>
    </ux-iws-link-wrapper>`;
};

export const DoubleTeaserTileTemplate = () => html`
    <div class="ux-iws-double-teaser-tile ux-u-mt-fluid-xs ux-u-mb-fluid-xs">
        <h2
            class="ux-iws-double-teaser-tile__title ux-text-headline ux-text-headline--big"
        >
            Bei TRUMPF gibt es die passende Fertigungslösung für jede:
        </h2>
        <div class="ux-iws-double-teaser-tile__tiles-wrapper">
            ${TeaserTileTemplate({
                imgDimensions: [769, 357],
                title: "Anwendung",
            })}
            ${TeaserTileTemplate({
                imgDimensions: [770, 360],
                title: "Branche",
            })}
        </div>
    </div>
`;
